if (typeof metricsLogGuid !== 'undefined' && metricsLogGuid != null) {
	const productElementCollection = document.getElementsByClassName('td-product');
	if (productElementCollection) {
		for (var i = 0; i < productElementCollection.length; i++) {
			var element = productElementCollection[i];
			element.addEventListener('click', function (event) {
				// Track click as it is set to open. Ignore clicks to close
				if (event.currentTarget.parentElement.dataset.open == "true") {
					var xhttp = new XMLHttpRequest();
					const data = { CompanyProductBlockId: event.currentTarget.dataset.productid, MetricsLogGuid: metricsLogGuid };

					xhttp.open("POST", "/MetricsTracking/LogCompanyProductClick", true);
					xhttp.setRequestHeader("Content-type", "application/json");
					xhttp.send(JSON.stringify(data));
				}
			});
		};
	}

	const adItemElementCollection = document.getElementsByClassName('adItem');
	if (adItemElementCollection) {
		for (var i = 0; i < adItemElementCollection.length; i++) {
			var element = adItemElementCollection[i];
			element.addEventListener('click', function (event) {
				var xhttp = new XMLHttpRequest();
				const data = { AdItemBlockId: event.currentTarget.dataset.advertisementitemid, MetricsLogGuid: metricsLogGuid };

				xhttp.open("POST", "/MetricsTracking/LogAdClick", true);
				xhttp.setRequestHeader("Content-type", "application/json");
				xhttp.send(JSON.stringify(data));
			});

			var adViewHttpRequest = new XMLHttpRequest();
			const adViewData = { AdItemBlockId: element.dataset.advertisementitemid, MetricsLogGuid: metricsLogGuid };

			adViewHttpRequest.open("POST", "/MetricsTracking/LogAdView", true);
			adViewHttpRequest.setRequestHeader("Content-type", "application/json");
			adViewHttpRequest.send(JSON.stringify(adViewData)); 
		};
	}


	const trackableLinkElementCollection = document.getElementsByClassName('trackable-link');
	if (trackableLinkElementCollection) {
		for (var i = 0; i < trackableLinkElementCollection.length; i++) {
			var element = trackableLinkElementCollection[i];
			element.addEventListener('click', function (event) {
				var xhttp = new XMLHttpRequest();
				const data =
				{
					AdvertiserBlockId: event.currentTarget.dataset.advertiserId,
					MetricsLogGuid: metricsLogGuid,
					Href: event.currentTarget.href,
					LinkText: event.currentTarget.textContent
				};

				xhttp.open("POST", "/MetricsTracking/LogExternalLinkClick", true);
				xhttp.setRequestHeader("Content-type", "application/json");
				xhttp.send(JSON.stringify(data));
			});
		};
	}

	const trackableRegisterButtons = document.getElementsByClassName('register-button');
	if (trackableRegisterButtons) {
		for (var i = 0; i < trackableRegisterButtons.length; i++) {
			var element = trackableRegisterButtons[i];
			element.addEventListener('click', function (event) {
				var xhttp = new XMLHttpRequest();
				const data =
				{
					EventPageId: event.currentTarget.dataset.eventPageId,
					MetricsLogGuid: metricsLogGuid,
					Href: event.currentTarget.href,
				};

				xhttp.open("POST", "/MetricsTracking/LogEventRegistrationButtonClick", true);
				xhttp.setRequestHeader("Content-type", "application/json");
				xhttp.send(JSON.stringify(data));
			});
		};
	}

	const videoItemCollection = document.getElementsByClassName('wistia_responsive_wrapper');
	if (videoItemCollection) {
		for (var i = 0; i < videoItemCollection.length; i++) {
			var element = videoItemCollection[i];
			element.addEventListener('click', function (event) {
				var xhttp = new XMLHttpRequest();

				if (event.currentTarget.dataset.videoStarted == 'false') {
					event.currentTarget.dataset.videoStarted = 'true';
					const data =
					{
						VideoBlockId: event.currentTarget.dataset.videoBlockId,
						MetricsLogGuid: metricsLogGuid
					};

					xhttp.open("POST", "/MetricsTracking/LogVideoClick", true);
					xhttp.setRequestHeader("Content-type", "application/json");
					xhttp.send(JSON.stringify(data));
				}

			});
		};
	}

	const socialShareElementCollection = document.getElementsByClassName('share__social-item');
	for(var i = 0; i<socialShareElementCollection.length; i++){
		var element = socialShareElementCollection[i];                
		element.addEventListener('click', function(event){
			var xhttp = new XMLHttpRequest();
			var data = 
			{ 
				MetricsLogGuid: metricsLogGuid,
				Href: event.currentTarget.querySelector('a').href 
			}; 

			xhttp.open("POST", "/MetricsTracking/LogSocialShareClick", true);
			xhttp.setRequestHeader("Content-type", "application/json");
			xhttp.send(JSON.stringify(data));
		});
	}	
}


// WEBPACK FOOTER //
// ../components/metrics/metricsTracking.js